import SiteMap from "@/components/SiteMap";

export default function SitesPage() {
  return (
    <div>
      {/* Hero */}
      <section style={{ backgroundColor: "#2d2d2d" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 pt-28 pb-14 md:py-20">
          <p
            className="text-xs uppercase tracking-[0.25em] font-semibold mb-6 opacity-0 animate-fade-up"
            style={{ color: "#d4782f" }}
          >
            PadSite Locations
          </p>
          <h1
            className="text-3xl sm:text-5xl lg:text-6xl font-bold tracking-tighter leading-[1.08] mb-6 opacity-0 animate-fade-up animate-delay-1"
            style={{ color: "#FFFFFF" }}
          >
            Available Sites Across Metro Atlanta.
          </h1>
          <p
            className="text-base md:text-lg leading-relaxed max-w-2xl opacity-0 animate-fade-up animate-delay-2"
            style={{ color: "rgba(255,255,255,0.75)" }}
          >
            View available, leased, and pending PadSite locations. Find the right
            site for your next restaurant operation.
          </p>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ backgroundColor: "#F4F5F7" }}>
        <div className="w-full max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-24 py-10 md:py-16">
          <SiteMap />
        </div>
      </section>
    </div>
  );
}
